// extracted by mini-css-extract-plugin
export default {"FormModalContainer":"TwoColumnModal_FormModalContainer__G17aX","InsideContainer":"TwoColumnModal_InsideContainer__Ec02s","ModalHeader":"TwoColumnModal_ModalHeader__E3b5p"};